import React, { useState, useEffect } from 'react';
import { FileText, Upload, Trash2, File } from 'lucide-react';
import { specsAPI } from '../../services/api';
import '../admin/AdminSections.css';

const SpecsSection = () => {
  const [specs, setSpecs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    loadSpecs();
  }, []);

  const loadSpecs = async () => {
    try {
      const res = await specsAPI.getAll();
      setSpecs(res.data);
    } catch (error) {
      console.error('Error loading specs:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      await specsAPI.upload(file);
      await loadSpecs();
    } catch (error) {
      alert('Σφάλμα κατά το ανέβασμα');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  const handleDelete = async (specId) => {
    if (!window.confirm('Διαγραφή αρχείου;')) return;
    try {
      await specsAPI.delete(specId);
      await loadSpecs();
    } catch (error) {
      alert('Σφάλμα κατά τη διαγραφή');
    }
  };

  const getFileIcon = (filename) => {
    const ext = filename.split('.').pop().toLowerCase();
    if (['pdf'].includes(ext)) return '#d32f2f';
    if (['doc', 'docx'].includes(ext)) return '#1565c0';
    if (['xls', 'xlsx'].includes(ext)) return '#2e7d32';
    if (['dwg', 'dxf'].includes(ext)) return '#6a1b9a';
    if (['jpg', 'jpeg', 'png'].includes(ext)) return '#e65100';
    return '#546e7a';
  };

  return (
    <div className="admin-section" data-testid="specs-section">
      <div className="section-header">
        <h2>
          <FileText size={24} />
          Προδιαγραφές & Τεχνικά Έγγραφα
        </h2>
        <label className="btn-primary" style={{ cursor: 'pointer', opacity: uploading ? 0.5 : 1 }}>
          <Upload size={16} />
          {uploading ? 'Ανέβασμα...' : 'Ανέβασμα Αρχείου'}
          <input
            type="file"
            onChange={handleUpload}
            style={{ display: 'none' }}
            disabled={uploading}
            data-testid="spec-upload-input"
          />
        </label>
      </div>

      <p style={{ color: '#666', marginBottom: '1.5rem', fontSize: '0.9rem' }}>
        Ανεβάστε τεχνικά σχέδια, προδιαγραφές, DWG, PDF και άλλα τεχνικά έγγραφα.
      </p>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '3rem' }}>
          <p>Φόρτωση...</p>
        </div>
      ) : specs.length === 0 ? (
        <div className="empty-state">
          <FileText size={48} />
          <p>Δεν υπάρχουν αρχεία προδιαγραφών</p>
          <p>Ανεβάστε τεχνικά έγγραφα χρησιμοποιώντας το κουμπί παραπάνω</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          {specs.map(spec => (
            <div key={spec.id} style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '1rem 1.25rem', border: '1px solid #e0e0e0', background: '#fafafa',
              transition: 'box-shadow 0.2s'
            }} data-testid={`spec-file-${spec.id}`}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flex: 1, minWidth: 0 }}>
                <File size={22} color={getFileIcon(spec.filename)} />
                <div style={{ minWidth: 0 }}>
                  <p style={{ margin: 0, fontWeight: 500, fontSize: '0.95rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {spec.filename}
                  </p>
                  <p style={{ margin: '0.2rem 0 0', fontSize: '0.8rem', color: '#999' }}>
                    {(spec.file_size / 1024).toFixed(1)} KB &middot; {new Date(spec.uploaded_at).toLocaleDateString('el-GR')}
                  </p>
                </div>
              </div>
              <button
                onClick={() => handleDelete(spec.id)}
                className="btn-icon danger"
                title="Διαγραφή"
                data-testid={`delete-spec-${spec.id}`}
              >
                <Trash2 size={16} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SpecsSection;
